import { useEffect, useState } from 'react'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { auth, db } from '../../../../firebase/firebase'
import styled from './Reviews.module.css'
import Navbar from '../../../../components/navbar/Navbar'
import GoBackButton from '../../../../components/buttons/GoBackButton'
import { useTranslation } from 'react-i18next'

function formatWhen(value) {
  if (!value) return ''
  const date = value?.toDate?.() || new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString('en-GB')
}

const Reviews = () => {
  const { t } = useTranslation()
  const [comments, setComments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const fetchComments = async () => {
      const currentUser = auth.currentUser
      if (!currentUser) {
        setLoading(false)
        setError('Not signed in')
        return
      }

      try {
        const q = query(
          collection(db, 'students', currentUser.uid, 'comments'),
          where('status', '==', 'approved')
        )
        const snap = await getDocs(q)
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        rows.sort((a, b) => {
          const aTime = a.createdAt?.toMillis?.() || 0
          const bTime = b.createdAt?.toMillis?.() || 0
          return bTime - aTime
        })
        setComments(rows)
      } catch (err) {
        setError(err.message || 'Failed to load comments')
        setComments([])
      } finally {
        setLoading(false)
      }
    }

    fetchComments()
  }, [])

  return (
    <>
      <Navbar />
      <div className={styled.container}>
        <h3 className={styled.header}>{t('Reviews.Your Comments')} : </h3>
        {loading ? (
          <p>Loading…</p>
        ) : error ? (
          <p>{error}</p>
        ) : comments.length === 0 ? (
          <p>{t('Reviews.There are no comments yet for you.')}</p>
        ) : (
          <div className={styled.box}>
            {comments.map((comment) => (
              <div className={styled.text} key={comment.id}>
                <p>{comment.text}</p>
                <p style={{ fontSize: '0.85rem', opacity: 0.75 }}>
                  {comment.teacherName || 'Teacher'}
                  {comment.createdAt ? ` · ${formatWhen(comment.createdAt)}` : ''}
                </p>
              </div>
            ))}
          </div>
        )}
        <GoBackButton>{t('Reviews.Go Back')}</GoBackButton>
      </div>
    </>
  )
}

export default Reviews
